import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";

export default class StopImpersonatingCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onClick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.props.stopImpersonating(this.props.history);
        };
    }

    render() {
        const {
            localization
        } = this.props;

        return (
            <div className="card-default">
                <div style={{display:"flex"}} >
                    <div className="dashboard-myproductlist-body">
                        <label className="dashboard-card-header">
                            {localization.text("dashboard","adminChangeBackCustomer")}
                        </label>
                    </div>
                </div>
                <div className="dashboard-card-bottom">
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={12} lg={6}>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn primary block"} onClick={this.onClick}>
                                {localization.text("dashboard", "changeBackCustomer")}
                            </button>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </div>
        );
    }
}

StopImpersonatingCard.propTypes = {
    localization: Localization.propTypes.isRequired,
    stopImpersonating: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
};